module.exports = __webpack_public_path__ + "static/media/logo_farmRio.e452dd08.svg";